import * as fromDatatype from '../datatype-library/index';

export interface bl_t2t_comp_branch_entity_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  self_comp_guid: fromDatatype.GuidDataFieldInterface;
  self_branch_guid: fromDatatype.GuidDataFieldInterface;
  self_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  self_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  other_tenant_guid: fromDatatype.GuidDataFieldInterface;
  other_comp_guid: fromDatatype.GuidDataFieldInterface;
  other_branch_guid: fromDatatype.GuidDataFieldInterface;
  other_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  other_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_t2t_comp_branch_entity_link_RowCLass implements bl_t2t_comp_branch_entity_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  self_comp_guid: fromDatatype.GuidDataFieldInterface;
  self_branch_guid: fromDatatype.GuidDataFieldInterface;
  self_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  self_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  other_tenant_guid: fromDatatype.GuidDataFieldInterface;
  other_comp_guid: fromDatatype.GuidDataFieldInterface;
  other_branch_guid: fromDatatype.GuidDataFieldInterface;
  other_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  other_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
}